<template>
  <div>
    <div class="project-code-item v-center" @click="selectProductCode">
      <settings-bar
        :selected="isSelected"
        :title=" productCodeName"
        :materialId="materialId"
      >
        <template #icon-slot>
          <div
          :key="`status-${productStatus}`"
          v-tooltip="getStatusTooltip(productStatus)"
          :class="['material-status', getStatusClass(productStatus)]"
          ></div>
        </template>
      </settings-bar>
    </div>
  </div>
</template>

<script>
import config from '@/config.js'
import settingsBar from '../../common/settingsBar.vue'
export default {
  components: { settingsBar },
  name: 'ProjectCodeItem',
  props: {
    productObject: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {}
  },
  computed: {
    productCode () {
      return this.productObject.product_code
    },
    productCodeName () {
      return this.productObject.product_code_name
    },
    materialId () {
      return this.productObject?.material_id
    },
    productStatus () {
      return this.productObject.status || (this.productObject.active ? 1 : 2)
    },
    isSelected () {
      const selectedId = this.$store.getters['projectBom/selectedProductCodeId']
      return selectedId != null && String(selectedId) === String(this.productCode)
    }
  },
  methods: {
    selectProductCode () {
      this.$router.push(`/bom/project/${this.productCode}`).catch(() => {})
    },
    getStatusClass (status) {
      switch (status) {
      case config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE:
        return 'status-active'
      case config.MATERIAL_STATUS_INVERTED_MAP.OBSELETE:
        return 'status-obsolete'
      case config.MATERIAL_STATUS_INVERTED_MAP.LOCKED:
        return 'status-locked'
      case config.MATERIAL_STATUS_INVERTED_MAP.RELEASED:
        return 'status-released'
      default:
        return ''
      }
    },
    getStatusTooltip (status) {
      switch (status) {
      case config.MATERIAL_STATUS_INVERTED_MAP.ACTIVE:
        return 'Active'
      case config.MATERIAL_STATUS_INVERTED_MAP.OBSELETE:
        return 'Obsolete'
      case config.MATERIAL_STATUS_INVERTED_MAP.LOCKED:
        return 'Locked'
      case config.MATERIAL_STATUS_INVERTED_MAP.RELEASED:
        return 'Released'
      default:
        return 'Unknown status'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$status-colors: (
  active: #16A34A,
  released: #2563EB,
  obsolete: #6B7280,
  locked: #DC2626
);

.material-status {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);

  @each $name, $color in $status-colors {
    &.status-#{$name} {
      background-color: $color;
    }
  }
}
.project-code-item {
  // border: 1px solid var(--brand-color);
  // background-color: rgba(var(--brand-rgb), 0.2);
  margin: 1px 0px;

  // padding-left: 6px;
  cursor: pointer;
    ::v-deep(.card-content) {
    padding: 8px 10px;
  }

  ::v-deep(.title) {
    min-width: 0;
  }

  ::v-deep(.text-section) {
    min-width: 0;
    flex: 1;
  }
  &.selected {
    background-color: rgba(var(--brand-rgb), 0.6);
  }
  &__name {
    width: calc(100% - 30px);
    height: 30px;
  }
  & .toggle-button {
    height: 30px;
    width: 30px;
    background-color: rgba(var(--brand-rgb), 1);
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
    &.active {
      opacity: 1;
      cursor: pointer;
      pointer-events: all;
    }
    &.rotate {
      img {
        transform: rotate(0deg);
      }
    }
    & img {
      height: 16px;
      width: 16px;
      transform: rotate(-90deg);
    }
  }
}
</style>
